import React from "react";
import GET from "../../utils/GET";
import makeLink from "../../utils/makeLink";
import validEmail from "../../utils/validEmail";
import { ThemeButton } from "../CoreUI";
import "./order-confirmation.css";
import { FiMail } from "react-icons/fi";
import { FaTruck, FaTwitter } from "react-icons/fa";
import { TiSocialFacebookCircular as FbIcon } from "react-icons/ti";
import { AiFillInstagram } from "react-icons/ai";

import { eventTypes } from "../../hooks/useTrack";

const userName = GET("name") || (GET("platform") ? "Marlowe" : false);
const step = GET("step");
const trackingInfo = GET("trackingInfo");
const trackingLink = GET("trackingLink");
const contactEmail = GET("contactEmail");
const dummy = !!(GET("platform") || GET("full"));
const orderNo = GET("identifier");

const OrderConfirmation = ({ publisher }) => {
	const fbLink = makeLink(publisher.facebook, "facebook.com");
	const twitterLink = makeLink(publisher.twitter, "twitter.com");
	const instaLink = makeLink(publisher.instagram, "instagram.com");

	return (
		<section className="order-confirmation-container">
			{orderNo && (
				<div className="order-confirmation-number">
					Order #{orderNo}
				</div>
			)}
			<div className="order-confirmation-text">
				Thank you
				<span>{userName ? `, ${userName}` : ""}!</span>
				<br />
				Your order {step === "delivered" ? "has been" : "is"}{" "}
				{step ? step : "confirmed"}.
			</div>

			{trackingInfo && (
				<div className="order-confirmation-tracking-info">
					{trackingInfo}
				</div>
			)}
			<section className="order-confirmation-action">
				{((contactEmail && validEmail(contactEmail)) || dummy) && (
					<ThemeButton
						event={eventTypes.WIDGET_CONTACT_US_CLICK}
						link={dummy ? "" : `mailto:${contactEmail}`}
						icon={<FiMail />}
					>
						Contact Us
					</ThemeButton>
				)}

				{(dummy || trackingLink) && (
					<ThemeButton
						event={eventTypes.WIDGET_TRACK_ORDER_CLICK}
						link={dummy ? "" : trackingLink}
						icon={<FaTruck />}
					>
						Track order
					</ThemeButton>
				)}
				{instaLink && (
					<ThemeButton
						event={eventTypes.WIDGET_SHOP_INSTA_CLICK}
						link={instaLink}
						iconOnly
						iconStyle={{
							fontSize: "1.6rem",
						}}
						icon={<AiFillInstagram />}
					/>
				)}
				{twitterLink && (
					<ThemeButton
						event={eventTypes.WIDGET_SHOP_TWITTER_CLICK}
						link={twitterLink}
						iconOnly
						icon={<FaTwitter />}
					/>
				)}
				{fbLink && (
					<ThemeButton
						event={eventTypes.WIDGET_SHOP_FB_CLICK}
						link={fbLink}
						iconOnly
						iconStyle={{
							fontSize: "1.8rem",
						}}
						icon={<FbIcon />}
					/>
				)}
			</section>
		</section>
	);
};

export default OrderConfirmation;
